import axios from 'axios';

const getEdit = (url, headers) => axios.get(url, { headers });

export default getEdit;
